import {
  LOG_IN,
  LOG_OUT,
  AUTH_ERROR,
  UPDATE_SESSION_ID,
  SESSION_MISMATCH,
  VIEW_USER_REPORTS,
} from "../types";
import browserInfo from "../../tools/browserInfo";

const defaultAuth = {
  loggedIn: false,
  id: 0,
  sessionMismatch: false,
  browser: browserInfo,
  error: false,
  user: false,
  viewUserReports: false,
  getError() {
    const err = this.error;
    this.error = false;
    return err;
  },
  clearError() {
    this.error = false;
  },
};

export default function (state = defaultAuth, action) {
  switch (action.type) {
    case LOG_IN:
      const user = action.user;
      return { ...state, loggedIn: true, user: user ? user : state.user };
    case LOG_OUT:
      return { ...state, loggedIn: false, user: "unknown" };
    case AUTH_ERROR:
      return { ...state, error: action.payload };
    case UPDATE_SESSION_ID:
      return { ...state, id: action.id };
    case SESSION_MISMATCH:
      return { ...state, sessionMismatch: true };
    case VIEW_USER_REPORTS:
      return { ...state, viewUserReports: action.payload };
    default:
      return state;
  }
}
